import { motion } from "framer-motion";

import { TertiaryButton } from "@shared/buttons";
import { Select } from "@shared/selects";
import { TextInput } from "@shared/text-input";

import { useFilteredMetrics } from "../../hooks/use-filtered-metrics";

import { MetricList } from "./metric-list";

interface Props {
  isDisabled?: boolean;
}

// TODO: Move to @components/v2 and use select from v2 components.
export const MetricSelector = ({ isDisabled }: Props) => {
  const {
    selectedCategory,
    setSelectedCategory,
    search,
    setSearch,
    categories,
    metricCategories,
  } = useFilteredMetrics();

  return (
    <div className="pt-4 h-[calc(100%-170px)] flex flex-col">
      <div className="text-gray+2 text-xs font-medium tracking-wider mb-2 px-4">
        INSERT METRIC
      </div>
      <div className="flex items-center">
        <div className="flex-grow px-4">
          <div className="text-interstellar+2 text-xs font-medium tracking-wide mb-1">
            METRIC CATEGORY
          </div>
          <Select
            className="mb-2"
            width="100%"
            isDisabled={isDisabled}
            value={selectedCategory}
            onChange={setSelectedCategory}
            options={categories}
          />
        </div>
      </div>
      <div className="px-4">
        <TextInput
          className="mb-2 text-sm"
          isDisabled={isDisabled}
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          placeholder="Search..."
          leftIcon={<i className="fa-regular fa-sharp fa-search" />}
        />
      </div>
      <MetricList
        isDisabled={isDisabled}
        metricCategories={metricCategories}
        clearSearch={() => setSearch("")}
        selectedCategory={selectedCategory}
      />
    </div>
  );
};

export const ConfirmAccountingMode = ({
  confirmAccountingMode,
  setIsConfirmingClear,
}: {
  confirmAccountingMode: () => void;
  setIsConfirmingClear: (value: boolean) => void;
}) => (
  <motion.div
    className="max-w-[14rem] mx-4 mt-1 px-3 py-1.5 bg-mars-2 rounded-md flex items-center"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.3, ease: "easeIn" }}
  >
    <div className="text-interstellar+2 text-xs mb-1">
      <span className="font-semibold">Switch modes and clear formula?</span>
    </div>
    <div className="flex space-x-2">
      <TertiaryButton
        className="text-mars hover:bg-mars-2 !h-4 py-0.5 px-2 flex items-center"
        onClick={confirmAccountingMode}
      >
        YES
      </TertiaryButton>
      <TertiaryButton
        className="!h-4 py-0.5 px-2 flex items-center"
        onClick={() => setIsConfirmingClear(false)}
      >
        NO
      </TertiaryButton>
    </div>
  </motion.div>
);
